import { render, staticRenderFns } from "./SystemMenus.vue?vue&type=template&id=a6dcf8d0&scoped=true"
import script from "./SystemMenus.vue?vue&type=script&lang=js"
export * from "./SystemMenus.vue?vue&type=script&lang=js"
import style0 from "./SystemMenus.vue?vue&type=style&index=0&id=a6dcf8d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6dcf8d0",
  null
  
)

export default component.exports